import { useRef, useState } from "react";

function Search({
  keyword,
  caseSensitive,
  onSearch,
  debounceTime,
  className,
  placeholder,
  name,
}) {
  let timer = useRef();
  const [value, setValue] = useState(keyword || "");
  const handleChange = (event) => {
    let inputValue = event.target.value;
    setValue(inputValue);
    if (!caseSensitive) {
      inputValue = inputValue.toLowerCase();
    }

    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      onSearch && onSearch(inputValue);
    }, debounceTime || 1000);
  };
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <svg
          className="h-4 w-4 text-gray-400 stroke-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
          stroke="1.5"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
      <input
        type="text"
        name="desktop-search-candidate"
        value={value}
        className={`${className} hidden w-full rounded-md border-0 py-1.5 pl-10 text-sm leading-6 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:block`}
        placeholder={placeholder || `Search ${name}...`}
        onChange={handleChange}
      />
    </div>
  );
}

export default Search;
